import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

export const mediaUrl = (p) => (p && p.startsWith("/") ? `${BACKEND_URL}${p}` : p);

export const downloadUrl = (pid, ext) => `${BACKEND_URL}/api/projects/${pid}/script.${ext}`;
